import { Transaction } from "@/jenesys-types/jenesys-entities/config";

import { CrudEdit } from "@/components/common/crud/CrudEdit/CrudEdit";
import { TransactionEditFormWrapper } from "@/routes/lazyFeatures";

export const TransactionsEditRoute: React.FC = () => (
  <CrudEdit<Transaction>
    form={TransactionEditFormWrapper}
    breadcrumbTitle="Transaction Details"
  />
);
